module.exports = __webpack_public_path__ + "img/workflow-en.8e4ed7c9.svg";